import SvgIcon from "@mui/material/SvgIcon";

interface CloseDrawerIconProps {
  children?: React.ReactNode;
  fontSize?: number | string;
  color?: string;
}

const CloseDrawerIcon: React.FC<CloseDrawerIconProps> = (props) => {
  return (
    <SvgIcon sx={{ fontSize: "inherit !important" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="closeDrawer"
        data-name="closeDrawer"
        viewBox="0 0 512 512"
        fill={props.color}
      >
        <g>
          <path d="m75 90h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
          <path d="m75 150h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
          <path d="m75 210h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
          <path d="m457 0h-402c-30.327 0-55 24.673-55 55v402c0 30.327 24.673 55 55 55h402c30.327 0 55-24.673 55-55v-402c0-30.327-24.673-55-55-55zm-257 482h-145c-13.785 0-25-11.215-25-25v-402c0-13.785 11.215-25 25-25h145zm282-241h-168.787l24.394-24.394c5.858-5.858 5.858-15.355 0-21.213s-15.355-5.858-21.213 0l-50 50c-5.858 5.858-5.858 15.355 0 21.213l50 50c5.858 5.858 15.355 5.858 21.213 0s5.858-15.355 0-21.213l-24.394-24.393h168.787v186c0 13.785-11.215 25-25 25h-227v-452h227c13.785 0 25 11.215 25 25z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default CloseDrawerIcon;
